import { Progress, Stack, Text } from "@mantine/core";
import { useAppSelector } from "../../../app/hooks";
import {
  selectAutoPipeRoutingIsPreparing,
  selectAutoPipeRoutingRunState,
  selectShouldShowAutoPipeRoutingRunProgress,
} from "../../pipeRoutingSlice";

export const AutoPipeRoutingRunProgress = () => {
  const shouldShow = useAppSelector(selectShouldShowAutoPipeRoutingRunProgress);
  const isPreparing = useAppSelector(selectAutoPipeRoutingIsPreparing);
  const runState = useAppSelector(selectAutoPipeRoutingRunState);

  if (!shouldShow) {
    return null;
  }

  if (isPreparing) {
    return (
      <Stack gap={6} w="100%">
        <Text size="sm" fw={500}>
          Forbereder rordragning...
        </Text>
        <Progress value={100} size="xl" radius="xl" w="100%" animated />
      </Stack>
    );
  }

  const progressPercent = Math.min(
    100,
    Math.max(0, (runState.currentIteration / runState.totalIterations) * 100)
  );

  return (
    <Stack gap={6} w="100%">
      <Text size="sm" fw={500}>
        Iteration {runState.currentIteration} / {runState.totalIterations}
      </Text>
      <Progress value={progressPercent} size="xl" radius="xl" w="100%" animated />
    </Stack>
  );
};
